import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import { useDispatch, useSelector } from 'react-redux';
import { addWishlist, removeFromWishlist } from '@/redux/thunk/wishlist-thunk';
import { addToWishlist } from '@/redux/reducers/wishlist-reducer';
import { setIsOpenLoginSignupWithCallback } from '@/redux/reducers/auth-reducer';
import { toggleModal } from '@/redux/reducers/wishlist-modal-reducer';
import wishlistModalsKeys from '@/constants/wishlistModals';
import { getProductNameWithModel } from '@/utils/string';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { useRouter } from 'next/navigation';
import Icon from '../Icon';

function WishListButton({ productData }) {
  const dispatch = useDispatch();
  const router = useRouter();

  const [isWishListedProduct, setIsWishListedProduct] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { items: wishlist } = useSelector((state) => state.wishlist);
  const windowDimensions = useWindowDimensions();

  const isProductInWishlist = (id) => {
    if (wishlist.length > 0) {
      const wishlistedProduct =
        wishlist.find((product) => Number(product.id) === Number(id)) ?? null;
      return wishlistedProduct;
    }
    return false;
  };

  useEffect(() => {
    if (isLoggedIn) {
      if (isProductInWishlist(productData?.id)) {
        setIsWishListedProduct(true);
      } else {
        setIsWishListedProduct(false);
      }
    }
  }, [productData, wishlist]);

  const handleWishlist = (id) => {
    if (isLoggedIn) {
      if (!isProductInWishlist(id)) {
        dispatch(addToWishlist({ id }));
        dispatch(addWishlist(id));
        setIsWishListedProduct(true);
        dispatch(
          toggleModal({
            modalType: wishlistModalsKeys.WISHLIST_NOTIFICATION,
            isOpen: true,
            data: productData,
          }),
        );
      } else {
        setIsWishListedProduct(false);
        dispatch(removeFromWishlist(id));
        dispatch(
          toggleModal({
            modalType: wishlistModalsKeys.COMMON_MODAL,
            isOpen: true,
            data: `${getProductNameWithModel(productData, 'en')} is removed from your Wishlist`,
          }),
        );
      }
    }

    if (!isLoggedIn) {
      if (windowDimensions?.width < 1024) {
        dispatch(
          setIsOpenLoginSignupWithCallback({
            state: false,
            onSuccessCallback: () => {
              dispatch(addToWishlist({ id }));
              dispatch(addWishlist(id));
              setIsWishListedProduct(true);
              dispatch(
                toggleModal({
                  modalType: wishlistModalsKeys.WISHLIST_NOTIFICATION,
                  isOpen: true,
                  data: productData,
                }),
              );
            },
          }),
        );
        router.push('/login');
      } else {
        dispatch(
          setIsOpenLoginSignupWithCallback({
            state: true,
            onSuccessCallback: () => {
              dispatch(addToWishlist({ id }));
              dispatch(addWishlist(id));
              setIsWishListedProduct(true);
              dispatch(
                toggleModal({
                  modalType: wishlistModalsKeys.WISHLIST_NOTIFICATION,
                  isOpen: true,
                  data: productData,
                }),
              );
            },
          }),
        );
      }
    }
  };

  return (
    <div className="absolute top-[1px] lg:top-[14px] right-0 lg:right-[6px] z-10">
      <Icon
        type={isWishListedProduct ? 'heart-fill' : 'heart'}
        className={cn(
          'size-[20px] lg:size-[24px] cursor-pointer',
          isClicked && 'animate-wishlist-scale',
        )}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsClicked(true);
          handleWishlist(productData?.id);
        }}
        onAnimationEnd={() => setIsClicked(false)} // Reset animation class
      />
    </div>
  );
}

export default WishListButton;
